import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import DataTableIcon from '@/assets/icons/DataTable';
import FWDChartIcon from '@/assets/icons/FWDChart';
import HighlightPriceIcon from '@/assets/icons/HighlightPrice';
import SimpleChartIcon from '@/assets/icons/SimpleChart';
import SpotHistoryTableIcon from '@/assets/icons/SpotHistoryTable';
import { DrawerStep } from '@/features/Dashboard/drawer/types';
import { AppType } from '@/features/Dashboard/types';

import { FORM_APP_DEFINITIONS } from './formRegistry';
import type { AppCatalogEntry } from './types';
import { Category } from './types';

export const APP_CATALOG: AppCatalogEntry[] = [
  {
    id: 'market-widget',
    step: DrawerStep.SelectMarketWidget,
    title: 'Import market widget',
    description: 'Imports widget from the existing market pages',
    icon: <DashboardOutlined />,
    category: Category.Markets,
    incompatibleWith: ['spot', 'fwd']
  },
  {
    id: 'spot-chart',
    step: DrawerStep.SelectSpotChart,
    title: 'Spot chart',
    description: 'Creates custom Spot History and Seasonal charts',
    icon: <SimpleChartIcon />,
    category: Category.Charts,
    premium: true,
    incompatibleWith: ['fwd']
  },
  {
    id: 'fwd-chart',
    step: DrawerStep.SelectFWDChart,
    title: 'Forward Curves chart',
    description: `Creates custom Forward Curves charts, up to ${FORM_APP_DEFINITIONS[AppType.FWD].maxItems} curves`,
    icon: <FWDChartIcon />,
    category: Category.Charts,
    premium: true,
    incompatibleWith: ['spot']
  },
  {
    id: 'basic-data-table',
    step: DrawerStep.SelectBasicDataTable,
    title: 'Basic data table',
    description: `Creates custom data table, up to ${FORM_APP_DEFINITIONS[AppType.Table].maxItems} items`,
    icon: <DataTableIcon />,
    category: Category.Data,
    incompatibleWith: ['fwd']
  },
  {
    id: 'highlighted-price',
    step: DrawerStep.SelectHighlightedPrice,
    title: 'Highlighted price',
    description: `Creates highlighted price at the top, up to ${FORM_APP_DEFINITIONS[AppType.Tiles].maxItems} items`,
    icon: <HighlightPriceIcon />,
    category: Category.Data,
    incompatibleWith: ['fwd']
  },
  {
    id: 'spothistorytable',
    step: DrawerStep.SpotHistoryTable,
    title: 'Spot history table',
    description: `Creates historical price table, up to ${FORM_APP_DEFINITIONS[AppType.SpotHistoryTable].maxItems} items`,
    icon: <SpotHistoryTableIcon />,
    category: Category.Data,
    badge: 'NEW!',
    incompatibleWith: ['fwd']
  }
];

export const catalogByStep = new Map(APP_CATALOG.map(app => [app.step, app]));
export const catalogById = new Map(APP_CATALOG.map(app => [app.id, app]));
